import _ from 'lodash';
import Cookies from 'js-cookie';
import {useSelector, useDispatch} from 'react-redux';

import HttpClient from 'sources/HttpClient';
import extractHttpResponse from 'sources/extractHttpResponse';
import {isUnauthorizeError, isInternalServer, isNotServerError} from 'sources/ApiError';
import useAsyncAction from 'components/helpers/hooks/useAsyncAction';
import {LOGOUT_BY_SERVER} from 'reducers/auth/authActions';

const request = new HttpClient();
let refreshingTokenPromise = null;

export default function useMakeApiRequest(
    method,
    defaultPath,
    reqDefaultParams = {},
    options = {},
) {
    const {onSuccess, onError} = options;
    const login = useSelector(({auth = {}}) => auth.login);
    const dispatch = useDispatch();
    const {
        data, files, params,
    } = reqDefaultParams;
    const parseResult = options.parseResult || _.identity;


    return useAsyncAction(
        async (dynamicReqParams = {}) => {
            try {
                const result = await request[method].call(
                    request,
                    dynamicReqParams.path || defaultPath,
                    {
                        params: {
                            ...params,
                            ...(dynamicReqParams.params || {}),
                        },
                        data: {
                            ...data,
                            ...dynamicReqParams.data,
                        },
                        files: files || dynamicReqParams.files
                            ? ({
                                ...files,
                                ...dynamicReqParams.files,
                            })
                            : null,
                    });

                const extractedResponse = await extractHttpResponse(result);

                return parseResult(extractedResponse);
            } catch (error) {
                if (isNotServerError(error)) console.error(error);

                if (isInternalServer(error)) console.error('Internal server error', error);
                if (isUnauthorizeError(error)) {
                    // If authorized but failed request by Unauthorized cause, try to refresh token and retry request
                    if (Cookies.get('isAuthorized')) {
                        const handler = () => {
                            refreshingTokenPromise = null;
                            return request[method].call(request,
                                dynamicReqParams.path || defaultPath,
                                {
                                    params: {
                                        ...params,
                                        ...(dynamicReqParams.params || {}),
                                    },
                                    data: {
                                        ...data,
                                        ...dynamicReqParams.data,
                                    },
                                    files: files || dynamicReqParams.files
                                        ? ({
                                            ...files,
                                            ...dynamicReqParams.files,
                                        })
                                        : null,
                                })
                                .then(extractHttpResponse)
                                .then(result => result);

                        };
                        if (refreshingTokenPromise) {
                            return refreshingTokenPromise.then(handler);
                        } else {
                            refreshingTokenPromise = request.post('/users/refreshToken');
                            return refreshingTokenPromise.then(handler).catch(() => dispatch({type: LOGOUT_BY_SERVER}));
                        }
                    }
                }

                throw error;
            }
        },
        onSuccess,
        onError,
    );


}



// WEBPACK FOOTER //
// ./src/sources/http/useMakeApiRequest.js